<script setup>
import { computed } from 'vue';
import BillingMeter from './BillingMeter.vue';

const props = defineProps({
  limits: {
    type: Object,
    default: () => ({}),
  },
  usage: {
    type: Object,
    default: () => ({}),
  },
});

const metrics = computed(() => [
  {
    key: 'agents',
    title: 'BILLING_SETTINGS.USAGE.AGENTS',
    icon: 'i-lucide-users',
    consumed: props.usage.agents || 0,
    total: props.limits.agents || 0,
  },
  {
    key: 'inboxes',
    title: 'BILLING_SETTINGS.USAGE.INBOXES',
    icon: 'i-lucide-inbox',
    consumed: props.usage.inboxes || 0,
    total: props.limits.inboxes || 0,
  },
  {
    key: 'contacts',
    title: 'BILLING_SETTINGS.USAGE.CONTACTS',
    icon: 'i-lucide-contact',
    consumed: props.usage.contacts || 0,
    total: props.limits.contacts || 0,
  },
  {
    key: 'messages',
    title: 'BILLING_SETTINGS.USAGE.MESSAGES',
    icon: 'i-lucide-message-square',
    consumed: props.usage.messages_this_month || 0,
    total: props.limits.messages_per_month || 0,
  },
  {
    key: 'automations',
    title: 'BILLING_SETTINGS.USAGE.AUTOMATIONS',
    icon: 'i-lucide-bot',
    consumed: props.usage.automations || 0,
    total: props.limits.automations || 0,
  },
  {
    key: 'campaigns',
    title: 'BILLING_SETTINGS.USAGE.CAMPAIGNS',
    icon: 'i-lucide-megaphone',
    consumed: props.usage.campaigns || 0,
    total: props.limits.campaigns || 0,
  },
]);

const filteredMetrics = computed(() => {
  return metrics.value.filter(m => m.total > 0);
});

const formatNumber = value => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return value.toString();
};
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div
      v-for="metric in filteredMetrics"
      :key="metric.key"
      class="p-4 rounded-xl bg-n-solid-3 border border-n-weak"
    >
      <div class="flex items-center gap-2 mb-3">
        <span class="text-n-slate-11" :class="[metric.icon]" />
        <span class="text-sm font-medium text-n-slate-12">
          {{ $t(metric.title) }}
        </span>
      </div>
      <BillingMeter
        title=""
        :consumed="metric.consumed"
        :total-count="metric.total"
      />
      <div class="flex justify-between mt-2 text-xs text-n-slate-10">
        <span>{{ formatNumber(metric.consumed) }}
          {{ $t('BILLING_SETTINGS.USAGE.USED') }}</span>
        <span>{{ formatNumber(metric.total) }}
          {{ $t('BILLING_SETTINGS.USAGE.LIMIT') }}</span>
      </div>
    </div>
  </div>
</template>
